var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 4.33331C5.55992 4.33331 5.33325 4.10665 5.33325 3.83331V1.83331C5.33325 1.55998 5.55992 1.33331 5.83325 1.33331C6.10659 1.33331 6.33325 1.55998 6.33325 1.83331V3.83331C6.33325 4.10665 6.10659 4.33331 5.83325 4.33331Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 4.33331C10.8934 4.33331 10.6667 4.10665 10.6667 3.83331V1.83331C10.6667 1.55998 10.8934 1.33331 11.1667 1.33331C11.4401 1.33331 11.6667 1.55998 11.6667 1.83331V3.83331C11.6667 4.10665 11.4401 4.33331 11.1667 4.33331Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 15.6666H5.83333C3.4 15.6666 2 14.2666 2 11.8333V6.16665C2 3.73331 3.4 2.33331 5.83333 2.33331H11.1667C13.6 2.33331 15 3.73331 15 6.16665V11.8333C15 14.2666 13.6 15.6666 11.1667 15.6666ZM5.83333 3.33331C3.92667 3.33331 3 4.25998 3 6.16665V11.8333C3 13.74 3.92667 14.6666 5.83333 14.6666H11.1667C13.0733 14.6666 14 13.74 14 11.8333V6.16665C14 4.25998 13.0733 3.33331 11.1667 3.33331H5.83333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1666 8.33331H5.83325C5.55992 8.33331 5.33325 8.10665 5.33325 7.83331C5.33325 7.55998 5.55992 7.33331 5.83325 7.33331H11.1666C11.4399 7.33331 11.6666 7.55998 11.6666 7.83331C11.6666 8.10665 11.4399 8.33331 11.1666 8.33331Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 11.6667H5.83325C5.55992 11.6667 5.33325 11.44 5.33325 11.1667C5.33325 10.8934 5.55992 10.6667 5.83325 10.6667H8.49992C8.77325 10.6667 8.99992 10.8934 8.99992 11.1667C8.99992 11.44 8.77325 11.6667 8.49992 11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteText);
export default __webpack_public_path__ + "static/media/note-text.a16cbfbf148cf4f31209a644aab94295.svg";
export { ForwardRef as ReactComponent };